<template>
  <div class="appServiceResourceAzureSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="5">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="5">
        <Input
          v-model="name"
          :placeholder="$t('RAM.common.filterByAccountName')"
        />
      </Col>
      <Col span="5">
        <Input
          v-model="accountName"
          :placeholder="$t('RAM.common.filterByAccountName')"
        />
      </Col>
      <Col span="5">
        <Input
          v-model="resourceGroup"
          :placeholder="$t('RAM.common.QuerybyResourceGroup')"
        />
      </Col>
      <Col span="4">
        <Button
          v-hasPermission="[
            'resourceConfigurationManagement:azure:appServiceResourceAzure:page'
          ]"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
import TableAppServiceResourceAzure from "../app_service/TableAppServiceResourceAzure";
var tableAppServiceResourceAzure = TableAppServiceResourceAzure;
export default {
  name: "AppServiceResourceAzureSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      name: "",
      accountName: "",
      resourceGroup: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("name", this.name);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("resourceGroup", this.resourceGroup);
      tableAppServiceResourceAzure.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.appServiceResourceAzureSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/app_service/AppServiceResourceAzureSearch.vue